import { UserDreamProfessionModel } from './UserDreamProfession';
import { Distance, HoursPerWeekPreference, SalaryPeriod, UserPreferredEducationLevel } from './VacancyEnums';

export interface VacancyPreferencesModel {
  distance: Distance;
  city: string | null;
  salary: number | null;
  salary_period: SalaryPeriod;
  hours_range: HoursPerWeekPreference;
  education_level: UserPreferredEducationLevel | null;
  dream_professions: UserDreamProfessionModel[] | null;
}
